import { isDev } from "@brexhq/shared/utils/env/isDevEnv";

import { INavigation } from "../components/navigation/types";
import { FooterData } from "../components/shared/Footer/types";

import { allFooters } from "./footer";
import { allNavs } from "./navigation";

/**
 *  Use JSON.stringify replacer parameter
  to swap prod for staging urls
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#using_a_function_as_replacer
 */
const replaceProdForStagingUrl = (_key: string, value: any) => {
  // If not a string  just return
  if (typeof value !== "string") {
    return value;
  }
  // Now its a string we can check if it contains reference to a dashboard url and replace if it does
  return value.includes("dashboard.brex.com")
    ? value.replace("dashboard.brex.com", "dashboard.staging.brexapps.com")
    : value;
};

/**
 * This replaces any production dashboard url in the Sanity navigation or footer data with the appropriate staging one in staging environments
 */
export const replaceStagingUrl = <T>(data: any): T => {
  if (isDev) {
    const replacedUrls = JSON.stringify(data, replaceProdForStagingUrl);
    // Parse back to json
    return JSON.parse(replacedUrls);
  }
  // If in prod just return the data that is passed into the function from sanity
  return data;
};

/**
 * returns either a nav by ID, or the default nav specified in site settings
 * @param id
 * @returns navigation object
 */
export const getNavById = (id: string) => {
  return replaceStagingUrl<INavigation>(allNavs[id]);
};

/**
 * returns either a nav by ID, or the default nav specified in site settings
 * @param id
 * @returns navigation object
 */
export const getFooterById = (id: string): FooterData => {
  return replaceStagingUrl<FooterData>(allFooters[id]);
};
